import { render } from "./RatingTuffstuff.vue?vue&type=template&id=40b33da0"
import script from "./RatingTuffstuff.vue?vue&type=script&lang=js"
export * from "./RatingTuffstuff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__